import React from 'react';

// Shared Components
import Icon from 'components/Icon';
import styles from './TableLabelWithIcon.scss';

export default function TableLabelWithIcon({ children = 'No Name', iconType }) {
  return (
    <div className={styles.tableName}>
      <Icon iconType={iconType} className={styles.tableNameIcon} />
      <div className={styles.tableNameText}>{children}</div>
    </div>
  );
}
